import { createSlice } from '@reduxjs/toolkit'

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        clusters: [],
        sortModel: [],
        prodSortModel: [],
        povSortModel: [],
        tabValue: 'Production',
        searchCluster: '',
        syncInfo: [{
            label: 'Last sync time',
            key: 'lastSyncTime',
            value: "",
            color: '#006400'
        }, {
            label: 'Processed files count',
            key: 'fileProcessedCount',
            value: "",
            color: '#006400'
        }],
        isViewOwnedCluster: false,
    },
    reducers: {
        setClusters: (state, action) => {
            state.clusters = action.payload
        },
        setRefreshData: (state, action) => {
            state.refreshData = action.payload
        },
        setSortModel: (state, action) => {
            state.sortModel = action.payload
        },
        setProdSortModel: (state, action) => {
            state.prodSortModel = action.payload
        },
        setPOVSortModel: (state, action) => {
            state.povSortModel = action.payload
        },
        setSyncInfo: (state, action) => {
            for(const key in action.payload) {
                const infoObj = state.syncInfo.find(obj => obj.key === key)
                if (infoObj) {
                    Object.assign(infoObj, {
                        value: action.payload[key]
                    })
                }
            }
        },
        setIsViewOwnedCluster: (state, action) => {
            state.isViewOwnedCluster = action.payload
        },
        setTabValue: (state, action) => {
            state.tabValue = action.payload
        },
        setSearchCluster: (state, action) => {
            state.searchCluster = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const {
    setClusters,
    setRefreshData,
    setSortModel,
    setSyncInfo,
    setPOVSortModel,
    setProdSortModel,
    setIsViewOwnedCluster,
    setTabValue,
    setSearchCluster
 } = dashboardSlice.actions

export default dashboardSlice.reducer
